export default angular
  .module('doxy.common.services.throttle', [])
  .factory('throttle', function ($timeout) {
    return function (delay, noTrailing, callback, debounceMode) {
      var timeoutId;
      var lastExec = 0;

      if (typeof noTrailing !== 'boolean') {
        debounceMode = callback;
        callback = noTrailing;
        noTrailing = undefined;
      }

      var wrapper = function () {
        var elapsed = +new Date() - lastExec;
        var args = arguments;
        var exec = () => {
          lastExec = +new Date();
          callback.apply(this, args);
        };

        var clear = function () {
          timeoutId = undefined;
        };

        if (debounceMode && !timeoutId) {
          exec();
        }

        if (timeoutId) {
          $timeout.cancel(timeoutId);
        }

        if (debounceMode === undefined && elapsed > delay) {
          exec();
        } else if (noTrailing !== true) {
          timeoutId = $timeout(
            debounceMode ? clear : exec,
            debounceMode === undefined ? delay - elapsed : delay
          );
        }
      };

      return wrapper;
    };
  }).name;
